import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { Slide } from "react-slideshow-image";
import { MdEdit, MdDelete, MdBookmark, MdBookmarkBorder } from "react-icons/md";
import { selectProductById } from "../features/products/productsApiSlice";
import { useAddToCartMutation, useGetUserByIdQuery, useRemoveFromCartMutation } from "../features/users/usersApiSlice";
import { addToCart, removeFromCart, rollbackCart, selectCartItemIds } from "../features/users/userSlice";
import useAuth from "../hooks/useAuth";
import Loading from "./Loading";
import SafeHTML from "./SafeHTML";
import "react-slideshow-image/dist/styles.css";
import { productImageUrlPrefix, userImageUrlPrefix, ROUTES } from "../assets/data";
import left_arrow from "../assets/images/left_arrow.svg";
import right_arrow from "../assets/images/right_arrow.svg";

const ProductDetailBox = ({ product, page }) => {
  console.log({product});
  
  // const product = useSelector((state) => selectProductById(state, productId));
  const productId = product._id;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { id } = useAuth();
  const cartItemIds = useSelector(selectCartItemIds);
  const isInCart = cartItemIds.includes(productId);
  
  console.log({user: product?.user});
  
  // const { data: user, isLoading, isSuccess } = useGetUserByIdQuery(product?.user);
  
  const [addProductToCart] = useAddToCartMutation();
  const [removeFromCartMutation] = useRemoveFromCartMutation();
  const [imageLoaded, setImageLoaded] = useState(false);
  
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const onAddToCartClicked = async () => {
    dispatch(addToCart(product));
    try {
      await addProductToCart({ productId, userId: id });
    } catch (error) {
      console.error('Failed to add product to cart:', error);
      dispatch(rollbackCart());
    }
  };

  const onRemoveFromCartClicked = async () => {
    dispatch(removeFromCart(productId));
    try {
      await removeFromCartMutation({ productId, userId: id });
    } catch (error) {
      console.error('Failed to remove product from cart:', error);
      dispatch(rollbackCart());
    }
  };
  

  const properties = {
    prevArrow: (
      <button className="absolute left-2 top-[50%] -translate-y-1/2 rounded-full z-10 text-white transition-all">
        <img src={left_arrow} alt="Previous" className="w-8 h-8" />
      </button>
    ),
    nextArrow: (
      <button className="absolute right-2 top-[50%] -translate-y-1/2 rounded-full z-10 text-white transition-all">
        <img src={right_arrow} alt="Next" className="w-8 h-8" />
      </button>
    ),
  };

  return (
    <div className="bg-white rounded-lg shadow-lg overflow-hidden">
      <div className="aspect-w-16 aspect-h-9 relative">
        {product?.image?.length > 1 ? (
          <Slide
            duration={5000}
            transitionDuration={300}
            arrows={windowWidth > 640}
            autoplay
            pauseOnHover
            {...properties}
          >
            {product.image.map((slideImage, index) => (
              <div key={index} className="relative w-full h-full">
                <img
                  src={`${slideImage}`}
                  alt={`Product ${index + 1}`}
                  className={`w-full h-full object-cover transition-opacity duration-300 ${
                    imageLoaded ? 'opacity-100' : 'opacity-0'
                  }`}
                  onLoad={() => setImageLoaded(true)}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
              </div>
            ))}
          </Slide>
        ) : product?.image?.[0] ? (
          <div className="relative w-full h-full">
            <img
              src={`${product.image[0]}`}
              alt="Product"
              className={`w-full h-full object-cover transition-opacity duration-300 ${
                imageLoaded ? 'opacity-100' : 'opacity-0'
              }`}
              onLoad={() => setImageLoaded(true)}
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
          </div>
        ) : (
          <div className="relative w-full h-full bg-gray-200 flex items-center justify-center">
            <span className="text-gray-400">No image available</span>
          </div>
        )}
      </div>

      <div className="p-6">
        <div className="flex items-center justify-between mb-6">
          <div className="flex items-center space-x-4">
            <img
              src={`${product?.user?.userImage}`}
              alt="Seller"
              className="w-12 h-12 rounded-full border-2 border-gray-200"
            />
            <div>
              <h3 className="text-lg font-semibold text-gray-800">
                {product?.user?.firstName} {product?.user?.lastName}
              </h3>
              <p className="text-sm text-gray-500">Seller</p>
            </div>
          </div>

          <div className="flex space-x-2">
            {page === "myProductDetail" ? (
              <>
                <button
                  onClick={() => navigate(`${ROUTES.EDIT_PRODUCT}/${product._id}`)}
                  className="p-2 rounded-full bg-blue-500 text-white hover:bg-blue-600 transition-colors"
                >
                  <MdEdit size={20} />
                </button>
                <button className="p-2 rounded-full bg-red-500 text-white hover:bg-red-600 transition-colors">
                  <MdDelete size={20} />
                </button>
              </>
            ) : (
              <button
                onClick={() => isInCart ? onRemoveFromCartClicked() : onAddToCartClicked()}
                className="p-2 rounded-full bg-gray-100 hover:bg-gray-200 transition-colors"
              >
                {isInCart ? (
                  <MdBookmark size={24} className="text-blue-500" />
                ) : (
                  <MdBookmarkBorder size={24} className="text-blue-500" />
                )}
              </button>
            )}
          </div>
        </div>

        <div className="space-y-4">
          <div>
            <h2 className="text-2xl font-bold text-gray-900">
              {product.brand.name} - {product.product_name}
            </h2>
            {product.need === "Sell" && (
              <div className="mt-2 space-y-1">
                <p className="text-green-500 italic capitalize">{product.condition}</p>
                <p className="text-xl font-semibold text-gray-900">ETB {product.price}</p>
              </div>
            )}
          </div>

          <div>
            <h3 className="text-lg font-semibold text-gray-800 mb-2">Description</h3>
            <SafeHTML 
              html={product.description} 
              className="text-gray-600 leading-relaxed"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductDetailBox;